import React from 'react';
/**
 * Hook that manages an interval callback, running a function at each step,
 * and storing the calculated value in state.
 * @param props - Props {@link UseIntervalProps}
 * @returns The most recently calculated value
 */
export function useInterval(_a) {
    var fn = _a.fn, _b = _a.ms, ms = _b === void 0 ? 1000 : _b;
    var _c = React.useState(fn()), value = _c[0], setValue = _c[1];
    var tick = function () {
        setValue(fn());
    };
    React.useEffect(function () {
        var timer = setInterval(tick, ms);
        return function () {
            clearInterval(timer);
        };
    });
    return value;
}
